export default {
    //去空格
    trim: function( text ) {
        let rTrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
        return text == null ? "" : ( text + "" ).replace( rTrim, "" );
    },
    //...
    abcd: function () {
      var c =  window.localStorage.getItem("abcd")
      if (this.trim(c)==''){
        c = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
          return v.toString(16);
        });
        window.localStorage.setItem('abcd',c);
      }
      return c;
    }
}



// WEBPACK FOOTER //
// ./src/lib/Helper.js